import {
  Foldable,
  HintContent,
  HintElement,
  HintStep,
  InlineNotice,
  InlineNoticeType,
  Modal,
  Reaction,
  ReactionConfig,
  ShowMore,
} from './types'

export const image = (src: string): HintElement => ({
  type: 'image',
  value: src,
})

export const text = (value: string): HintElement => ({
  type: 'text',
  value,
})

export const showMore = (
  labelToOpen?: string,
  labelToClose?: string
): ShowMore => ({
  type: 'showMore',
  labelToOpen,
  labelToClose,
})

export const foldable = (label: string, contents: HintContent[]): Foldable => ({
  type: 'foldable',
  label,
  contents,
})

export const noKeywordStep = (
  buttonTitle: string,
  contents: HintContent[]
): HintStep => ({
  buttonTitle,
  contents,
})

export const keywordStep =
  (...keywords: string[]) =>
  (buttonTitle: string, contents: HintContent[]): HintStep => ({
    keywords,
    buttonTitle,
    contents,
  })

export const keywordReaction = (
  keywords: string[],
  reaction: Reaction
): ReactionConfig => ({
  keywords,
  reaction,
})

const inlineNotice = (
  noticeType: InlineNoticeType,
  message: string
): InlineNotice => ({
  type: 'inlineNotice',
  noticeType,
  message,
})

const modal = (contents: HintContent[]): Modal => ({
  type: 'modal',
  contents,
})

export const reaction = {
  inlineNotice,
  modal,
}
